/**
 * The sandboxed frame an email is previewed in — lifted out of
 * `Workspace.tsx` in Block 1.2, where the MJML editor needed it and
 * importing it from a 4,000-line file was not an option.
 *
 * `sandbox=""` is the whole point: no scripts, no forms, no navigation, no
 * same-origin access. The frame renders on the one honest white in the app
 * (see `.preview-frame`), because a mail client renders on white and a
 * preview tinted to the brand ground shows something nobody will receive.
 *
 * Two shapes arrive here. An SDR draft is a FRAGMENT and is wrapped in the
 * body a mail client would give it; a compiled MJML document is complete —
 * doctype, head, styles and all — and is shown as it is.
 */

export function PreviewFrame({
  html,
  document = false,
  title = 'Email preview',
  className = 'preview-frame',
}: {
  html: string;
  /** True when `html` is already a complete document. */
  document?: boolean;
  title?: string;
  className?: string;
}) {
  const srcDoc = document
    ? html
    : `<!doctype html><html><head><meta charset="utf-8"></head><body style="margin:16px;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.5;color:#111">${html}</body></html>`;
  return <iframe className={className} title={title} sandbox="" srcDoc={srcDoc} />;
}
